export default __webpack_public_path__ + "static/media/1 (14).7c798c9f.jpg";